module.exports = __webpack_public_path__ + "static/media/combo-classic-icon.69da68c4.svg";